export default "__VITE_ASSET__CXpSZKru__"